import BaseDatePickerController from "./base_date_picker_controller"

/**
 * Public date picker — inherits all behavior from base.
 * Registered as "public-date-picker" via filename convention.
 */
export default class extends BaseDatePickerController {
}
